'use client';

import { useEffect, useState } from 'react';
import YouTube from 'react-youtube';

export const YouTubePayler = ({
    videoId,
    heightRatio = 0.58,
    minHeight   = 280,
    maxHeight   = 680,
    maxWidth    = 960,
    onPlay,
    onPause,
}) => {
    const [height,  setHeight]  = useState(480);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const calc = () => {
            const raw     = window.innerHeight * heightRatio;
            const clamped = Math.min(Math.max(raw, minHeight), maxHeight);
            setHeight(Math.round(clamped));
        };
        calc();
        window.addEventListener('resize', calc);
        return () => window.removeEventListener('resize', calc);
    }, [heightRatio, minHeight, maxHeight]);

    return (
        <div
            style={{
                position: 'relative',
                width: '100%',
                maxWidth,
                height,
                borderRadius: 12,
                overflow: 'hidden',
                background: '#000',
                boxShadow: '0 24px 64px rgba(0,0,0,0.7), 0 0 0 1px rgba(27,184,167,0.15)',
            }}
        >
                {/* Loading overlay */}
                {loading && (
                    <div style={{
                        position: 'absolute', inset: 0, zIndex: 10,
                        background: 'rgba(7,13,28,0.9)',
                        backdropFilter: 'blur(4px)',
                        display: 'flex', flexDirection: 'column',
                        alignItems: 'center', justifyContent: 'center', gap: 14,
                    }}>
                        {/* Teal spinner */}
                        <div style={{
                            width: 40, height: 40, borderRadius: '50%',
                            border: '3px solid rgba(255,255,255,0.08)',
                            borderTopColor: '#1bb8a7',
                            animation: 'ennix-spin 0.75s linear infinite',
                        }} />
                        <span style={{
                            fontSize: '0.7rem',
                            color: 'rgba(255,255,255,0.35)',
                            letterSpacing: '0.06em',
                            textTransform: 'uppercase',
                            fontWeight: 600,
                        }}>
                            Loading…
                        </span>
                    </div>
                )}

                <YouTube
                    videoId={videoId}
                    style={{ width: '100%', height: '100%', display: 'block' }}
                    opts={{
                        width:  '100%',
                        height: '100%',
                        playerVars: {
                            autoplay:        1,
                            mute:            0,
                            controls:        1,
                            rel:             0,
                            modestbranding:  1,
                            playsinline:     1,
                        },
                    }}
                    onReady={() => setLoading(false)}
                    onPlay={onPlay}
                    onPause={onPause}
                />
        </div>
    );
};
